import cn from 'classnames';
import { useCallback, useState } from 'react';

import Text from 'components/common/Text';
import PayPalCheckout from 'components/shared/PayPalCheckout';
import ApplePayCheckout from 'components/signUpFunnel/checkout/ApplePayCheckout';

const ExpressCheckoutSection = ({
  showPaymentOptions,
  setPayPalDetails,
  onPaypalClick,
  onApplePayClick,
  onApplePayComplete,
  onApplePayError,
}) => {
  const [applePayAvailable, setApplePayAvailable] = useState(null);

  const handleApplePayAvailabilityChange = useCallback(available => {
    setApplePayAvailable(available);
  }, []);

  if (!showPaymentOptions) {
    return null;
  }

  const showSideBySideLayout = applePayAvailable === true || applePayAvailable === null;
  const content = (
    <>
      <div
        className={cn('relative flex flex-col gap-4 pt-2', {
          'bp1:flex-row': showSideBySideLayout,
        })}
      >
        <div
          className={cn('min-h-[50px] w-full px-1 pr-1', {
            'bp1:w-1/2': showSideBySideLayout,
            'bp2:mx-auto bp2:w-1/2': !showSideBySideLayout,
          })}
        >
          <PayPalCheckout setPayPalDetails={setPayPalDetails} onPaypalClick={onPaypalClick} />
        </div>
        <div
          className={cn({
            'min-h-[50px] w-full pl-1 bp1:w-1/2': showSideBySideLayout,
            hidden: applePayAvailable === false,
          })}
        >
          <ApplePayCheckout
            onApplePayClick={onApplePayClick}
            onApplePayComplete={onApplePayComplete}
            onApplePayError={onApplePayError}
            onApplePayAvailabilityChange={handleApplePayAvailabilityChange}
          />
        </div>
      </div>
      <div className="text--hr-header text--hr-header--left text--hr-header--right my-4">
        <Text
          htmlElement="span"
          brandStylesOverrides="h7"
          className="text--hr-header__heading font-medium uppercase"
        >
          {' '}
          OR{' '}
        </Text>
      </div>
    </>
  );

  return <div data-testid="express-checkout-wrapper">{content}</div>;
};

ExpressCheckoutSection.propTypes = {
  showPaymentOptions: PropTypes.bool.isRequired,
  setPayPalDetails: PropTypes.func.isRequired,
  onPaypalClick: PropTypes.func.isRequired,
  onApplePayClick: PropTypes.func,
  onApplePayComplete: PropTypes.func.isRequired,
  onApplePayError: PropTypes.func,
};

export default ExpressCheckoutSection;
